import {appearances as appearanceApi} from '../../api';

export const REQUEST_SLOT_ACTION = 'REQUEST_SLOT_ACTION';
export const RECEIVE_SLOT_SUCCESS = 'RECEIVE_SLOT_SUCCESS';
export const RECEIVE_SLOT_FAILURE = 'RECEIVE_SLOT_FAILURE';

const requestSlots = () => ({
  type: REQUEST_SLOT_ACTION,
});

const receiveSlotsSuccess = (slots) => ({
  type: RECEIVE_SLOT_SUCCESS,
  payload: {
    slots
  },
});

const receiveSlotsFailure = (error) => ({
  type: RECEIVE_SLOT_FAILURE,
  payload: {
    error
  },
});

export const getSlots = () =>
  (dispatch) => {
    dispatch(requestSlots());

    return appearanceApi.slots()
      .then( (response) => {
        dispatch(receiveSlotsSuccess(response.data));
      }).catch( (error) => {
        dispatch(receiveSlotsFailure(error));
      });
  }



// WEBPACK FOOTER //
// ./src/appearances/actions/slotActions.js